<template>
  <div>
    <div
      class="cardLayoutWrapper"
      v-if="item"
    >
      <div class="elem elem--span-1">
        <BasicTooltip label="Avec mandat de gestion">
          <BasicIcon
            v-if="item.estSousMandatGestion"
            name="document-text"
            active
          />
        </BasicTooltip>
      </div>
      <div class="elem elem--span-1">
        <BasicTooltip label="Avec subrogation">
          <BasicIcon
            v-if="item.avecSubrogation"
            name="wallet"
            :active="false"
          />
        </BasicTooltip>
      </div>
      <div class="elem elem--span-3 elem--clickable">
        <span @click="ouvrirDemande(item.dispositif, item.id)">
          {{ item?.id }}
        </span>
      </div>
      <div class="elem elem--span-2">{{ item.dispositif }}</div>
      <div class="elem elem--span-6 elem--nowrap">
        <span>
          {{ item?.intitule }}
        </span>
      </div>
      <div class="elem elem--span-3">{{ dateFormatter(item.dateFormation?.start) }}</div>
      <div class="elem elem--span-3">{{ dateFormatter(item.dateFormation?.end) }}</div>
      <div class="elem elem--span-5 elem--nowrap">
        <span>
          {{ item?.adherent?.denomination }}
        </span>
      </div>
      <div class="elem elem--span-4 elem--clickable elem--nowrap">
        <span @click="showDrawer = !showDrawer">
          {{ stagiaires }}
        </span>
      </div>
      <div class="elem elem--span-4">
        <BasicTooltip :label="StatutLibelle[item.statut]">
          <BasicBadge
            :type="StatutBadgeType[item.statut] as BadgeType"
            :deletable="false"
            :label="StatutLibelle[item.statut]"
          />
        </BasicTooltip>
      </div>
      <div class="elem elem--span-1 elem--clickable"></div>
      <BasicTooltip :label="readonly ? 'Voir la demande' : 'Modifier la demande'">
        <div
          v-focusable="{ onEnter: () => ouvrirDemande(item.dispositif, item.id) }"
          class="elem elem--span-1 elem--clickable"
        >
          <BasicIcon
            :name="readonly ? 'eye' : 'edit'"
            :active="false"
            @click="ouvrirDemande(item.dispositif, item.id)"
          />
        </div>
      </BasicTooltip>
      <div
        v-if="checkClonePermission(item.dispositif)"
        v-focusable="{
          onEnter: clickClone,
        }"
        class="elem elem--span-1 elem--clickable"
      >
        <BasicTooltip label="Dupliquer la demande">
          <BasicIcon
            name="duplicate"
            :active="false"
            @click="clickClone"
          />
        </BasicTooltip>
      </div>
      <div
        v-focusable="{ focusable: !readonly, onEnter: () => deleteDemande(item.dispositif, item.id) }"
        class="elem elem--span-1 elem--clickable"
      >
        <BasicTooltip
          v-if="deletable"
          label="Supprimer la demande"
        >
          <BasicIcon
            name="trash"
            :active="false"
            @click="deleteDemande(item.dispositif, item.id)"
          />
        </BasicTooltip>
      </div>
    </div>
    <Transition name="open">
      <div
        v-if="showDrawer && (stagiairesList.length || prestatairesList.length)"
        class="listDrawerWrapper"
      >
        <div class="content">
          <ListDetails>
            <template #content>
              <div
                class="listDetailsElement"
                v-if="stagiairesList.length"
              >
                <span class="listDetailsTitle">Stagiaire(s)</span>
                <span class="listDetailsSubtitle">
                  {{ stagiairesList }}
                </span>
              </div>
              <div
                class="listDetailsElement"
                v-if="prestatairesList.length"
              >
                <span class="listDetailsTitle">Organisme(s)</span>
                <span
                  class="listDetailsSubtitle"
                  v-for="item in prestatairesList"
                  :key="item"
                >
                  {{ item }}
                </span>
              </div>
            </template>
          </ListDetails>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import type { BadgeType } from '@designSystem/components'
  import ListDetails from './ListDetails.vue'
  import type { RechercheResultDTO } from '@/features/api/extranet/dto/Demande/Recherche'
  import { useDemandeHelper } from './../useDemandeHelper'
  import { dateFormatter } from '@/features/shared/tools/date'
  import { useRechercheDemandeActions } from '../useRechercheDemandeActions'
  import { StatutLibelle, StatutBadgeType } from '@/features/domaine/types/opco'

  const { cloneDemande, deleteDemande, ouvrirDemande } = useRechercheDemandeActions()

  const props = defineProps<{ item: RechercheResultDTO }>()
  const { readonly, stagiaires, stagiairesList, prestatairesList, checkClonePermission, deletable } = useDemandeHelper(
    props.item,
  )
  const showDrawer = ref(false)

  const clickClone = () => {
    return cloneDemande({
      dispositif: props.item.dispositif,
      idDemande: props.item.id,
      idcc: props.item.adherent.idcc!.code,
      siret: props.item.adherent.siret.valeur!,
      permissions: props.item.niveauPermission,
    })
  }
</script>

<style scoped>
  @import '../../index.less';
</style>
